module.exports = __webpack_public_path__ + "static/media/back.eb1f61da.png";